export default class formConfig {
  // 企业登记信息 基本信息
  static basicInformation() {
    return [
      {
        title: "基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "企业名称：",
            value: "corpName",
            type: "input",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入企业名称",
              trigger: "blur"
            }
          },
          {
            label: "企业类型：",
            value: "isSmallEnterprise",
            type: "slot",
            slotName: "isSmallEnterprise",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择",
              trigger: "change"
            }
          },
          {
            label: "社会信用代码：",
            value: "corpCode",
            type: "slot",
            slotName: "corpCode",
            width: "100%",
            maxlength: 20,
            tip:
              "（三证合一填写统一社会信用代码；若未办理三证合一的营业执照则填写组织机构代码）",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入社会信用代码",
                trigger: "blur"
              },
              {
                pattern: /^[0-9a-zA-Z-_]*$/,
                message: "只能输入英文,_,数字，请重新输入！"
              }
            ]
          },
          {
            label: "招投标交易主体类别：",
            value: "corpRole",
            type: "checkbox",
            tip: "（此处可多选）",
            width: "100%",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择",
              trigger: "change"
            },
            option: [
              {
                label: "交易中介机构（招标代理）",
                value: "A"
              },
              {
                label: "交易竞争主体（投标人）",
                value: "B"
              },
              {
                label: "交易实施主体（招标人）",
                value: "T"
              }
            ]
          },
          {
            label: "法定代表人姓名：",
            value: "legalMan",
            type: "input",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入企业名称",
              trigger: "blur"
            }
          },
          {
            label: "法定代表人性别：",
            value: "legalManGender",
            type: "radio",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择",
              trigger: "blur"
            },
            option: [
              {
                label: "男",
                value: "0"
              },
              {
                label: "女",
                value: "1"
              }
            ]
          },
          {
            label: "法定代表人证件类型：",
            value: "idCardTypeNum",
            type: "select",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507052149470004"
            }
          },
          {
            label: "法定代表人证件号码：",
            value: "legalManIdCard",
            type: "input",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入法定代表人证件号码",
              trigger: "blur"
            }
          },
          {
            label: "法定代表人职务：",
            value: "legalManDuty",
            type: "input",
            disabled: false
          },
          {
            label: "法定代表人职称：",
            value: "legalManProTitle",
            type: "input",
            disabled: false
          },
          {
            label: "经营期限：",
            value: "operatingPeriod",
            type: "input",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入经营期限",
              trigger: "blur"
            }
          },
          {
            label: "法定代表人出生日期：",
            value: "legalManBirthDay",
            type: "date",
            required: true,
            disabled: false,
            valueFormat: "yyyy-MM-dd",
            TimePickerOptions: {
              disabledDate(date) {
                return date.getTime() > Date.now(); // 禁用大于今天的日期
              }
            },
            rule: {
              required: true,
              message: "请选择",
              trigger: "blur"
            }
          },
          {
            label: "办公电话：",
            value: "officePhone",
            type: "input",
            maxlength: "11",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入办公电话",
              trigger: "blur"
            }
          },
          {
            label: "传真号码：",
            value: "fax",
            type: "input",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入传真号码",
              trigger: "blur"
            }
          },
          {
            label: "企业网址：",
            value: "url",
            type: "input",
            disabled: false,
            tip: "（格式为：http://www.域名）"
          },
        ]
      },
    ];
  }
  // 企业登记信息 注册信息
  static registermessage() {
    return [
      {
        title: "注册信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "注册时间：",
            value: "insertDate",
            type: "input",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入注册时间",
              trigger: "blur"
            }
          },
          {
            label: "国别/地区：",
            value: "countryNum",
            type: "select",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201904102003580005"
            }
          },
          {
            label: "注册所在省（自治区、直辖市）：",
            value: "provinceNum",
            type: "select",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择",
              trigger: "change"
            },
            queryParams: {
              url: "/administrativeArea/administrativeAreaCombobox",
              zdid: "201507041523100004"
            }
          },
          {
            label: "注册所在地（市、州、盟）：",
            value: "cityNum",
            type: "select",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择",
              trigger: "change"
            },
            queryParams: {

            }
          },
          {
            label: "注册所在县（区、市、旗）：",
            value: "countyNum",
            type: "select",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择",
              trigger: "change"
            },
            queryParams: {

            }
          },
          {
            label: "住所：",
            value: "address",
            type: "input",
            tip: "（请填写营业执照的住所信息）",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入住所",
              trigger: "blur"
            }
          },
          {
            label: "企业登记注册类型：",
            value: "economicNum",
            type: "select",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507131651150072"
            }
          },
          {
            label: "住所邮政编码：",
            value: "postalCode",
            type: "input",
            tip: "（请填写营业执照的住所邮政编码）",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入住所邮政编码",
              trigger: "blur"
            }
          },
          {
            label: "注册资本（万元）：",
            value: "regPrin",
            type: "elNumber",
            disabled: false,
            rule: {
              required: false,
              message: "请填写注册资本",
              trigger: "blur"
            },
          },
          {
            label: "注册资本币种：",
            value: "principalUnitNum",
            type: "select",
            disabled: false,
            placeholder: "请选择",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507061217010003"
            }
          },
          {
            label: "成立日期：",
            value: "corpBirthDate",
            type: "date",
            required: true,
            disabled: false,
            valueFormat: "yyyy-MM-dd",
            TimePickerOptions: {
              disabledDate(date) {
                return date.getTime() > Date.now(); // 禁用大于今天的日期
              }
            },
            rule: {
              required: true,
              message: "请选择",
              trigger: "blur"
            }
          },
          {
            label: "资信等级：",
            value: "creditRate",
            type: "input",
            disabled: false
          },
          {
            label: "行业代码：",
            value: "industryClassCode",
            type: "cascader",
            placeholder: "请选择",
            url: "/industryCode/industryComboTree",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择",
              trigger: "change"
            },
            clearable: true,
            propsData: {
              value: "id",
              label: "industryName",
              children: "children",
              multiple: false
            }
          },
          {
            label: "经营范围：",
            value: "businessScope",
            type: "textarea",
            maxlength: 1000,
            tip: "最多可填1000个汉字",
            required: true,
            disabled: false,
            width: "100%",
            rule: {
              required: true,
              message: "请输入经营范围",
              trigger: "blur"
            }
          }
        ]
      },
    ];
  }
  // 企业登记信息 安全生产许可证
  static safetyProductionPermit() {
    return [
      {
        title: "安全生产许可证",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "证书编号：",
            value: "certId",
            type: "input",
            disabled: false
          },
          {
            label: "发证日期：",
            value: "organDate",
            type: "date",
            valueFormat: "yyyy-MM-dd",
            disabled: false
          },
          {
            label: "证书有效期截止日期：",
            value: "endDate",
            type: "date",
            valueFormat: "yyyy-MM-dd",
            disabled: false,
            TimePickerOptions: {
              disabledDate(date) {
                return date.getTime() < Date.now() - 24 * 60 * 60 * 1000; // 此条为设置禁止用户选择今天之前的日期，不包含今天
              }
            }
          }
        ]
      },
    ];
  }
  // 企业登记信息 平台账号管理员联系方式
  static administratorContact() {
    return [
      {
        title: "平台账号管理员联系方式",
        name: "1",
        icon: "",
        tipsList: [
          { type: "slot", slotName: "linkTips" }
        ],
        formConfigList: [
          {
            label: "联系人姓名：",
            value: "linkMan",
            type: "input",
            maxlength: "20",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入联系人姓名",
              trigger: "blur"
            }
          },
          {
            label: "联系人办公电话：",
            value: "linkTel",
            type: "input",
            maxlength: "11",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入联系人办公电话",
              trigger: "blur"
            }
          },
          {
            label: "联系人手机号码：",
            value: "linkPhone",
            type: "input",
            maxlength: "11",
            tip: "（短信通知号码）",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请输入联系人手机号码",
              trigger: "blur"
            }
          },
          {
            label: "联系邮箱：",
            value: "email",
            type: "input",
            tip: "（该邮箱为密保邮箱，请认真填写！）",
            required: true,
            disabled: false,
            rule: [
              { required: true, message: '请输入联系邮箱', trigger: 'blur' },
              { type: 'email', message: '请输入正确的联系邮箱', trigger: ['blur', 'change'] }
            ]
          },
        ]
      },
    ];
  }
  // 企业登记信息 外商投资
  static foreignInvestment() {
    return [
      {
        title: "外商投资",
        name: "1",
        tipsList: [
          { text: "（仅外商投资企业填写）" }
        ], 
        icon: "",
        class: "collapseList",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "list",
            class: "formList"
          }
        ]
      },
    ];
  }
  // 企业登记信息 备注
  static remark() {
    return [
      {
        title: "备注",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "备注信息：",
            value: "description",
            type: "textarea",
            maxlength: 1200,
            width: "100%",
            tip: "（最多可填1200个汉字）",
            disabled: false
          }
        ]
      },
      {
        title: "上传彩色扫描件",
        name: "1",
        icon: "",
        tipsList: [
          { type: "slot", slotName: "uploadTips" },
          { text: "（2）所有企业需上传新《公共资源交易事前信用承诺书》，删除旧承诺书，并重新核验。" },
          { text: "（3）完善资料：须上传法人身份证明、三证合一（或组织机构代码证、营业执照、税务登记证）、外商投资者身份证明；" },
          { text: "（4）更名：须上传加盖公章的《工商局变更证明》；" },
          { text: "（5）跨省变更：须上传加盖公章的《企业迁移通知书》、新的三证合一（或组织机构代码证、营业执照、税务登记证）；" },
          { text: "（6）分立/合并/重组：须上传加盖公章的《分立（合并/重组）证明》、新的三证合一（或组织机构代码证、营业执照、税务登记证）；" },
          { text: "（7）内外资变更：须上传加盖公章的《内外资变更证明》、外商投资者身份证明；" },
        ],
        formConfigList: [{
            label: "上传彩色扫描件：",
            type: "slot",
            slotName: "uploadBtn",
            width: "100%"
          },
        ]
      },
    ];
  }
  // 企业登记信息 变更记录
  static other() {
    return [
      {
        title: "变更记录",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "变更类型：",
            value: "modifyTypeId",
            type: "select",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择变更类型",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507131608570016"
            }
          },
          {
            label: "变更批准时间：",
            value: "modifyDate",
            type: "date",
            valueFormat: "yyyy-MM-dd",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择变更批准时间",
              trigger: "change"
            }
          },
          {
            label: "变更内容：",
            value: "modifyMark",
            type: "textarea",
            required: true,
            disabled: false,
            maxlength: 300,
            width: "100%",
            rule: {
              required: true,
              message: "请填写变更内容",
              trigger: "blur"
            }
          },
          {
            label: "历史变更记录：",
            type: "slot",
            slotName: "hisBtn",
          }
        ]
      },
      // {
      //   title: "其他",
      //   name: "2",
      //   icon: "",
      //   tipsList: [ { text: "已“通过”的企业信息，如再次提交，须重新进行信息核验，请谨慎操作！" } ],
      //   formConfigList: [
      //     {
      //       label: "核验记录：",
      //       value: "stateName",
      //       type: "slot",
      //       slotName: "stateName",
      //       width: "100%;",
      //       disabled: false
      //     },
      //   ]
      // },
      {
        title: "免责声明",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "disclaimer",
            class: "noMargin",
            width: "100%;"
          }
        ]
      },
      {
        title: "CA预约",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "caTips",
            class: "formList"
          }
        ]
      }
    ];
  }
}
